import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade, modal, alert } from '../../animacoes';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FiltroChecklistPipe } from '../pipes/filtro-checklist.pipe';

import { CheckAmbulanciaService } from '../services/check-ambulancia.service';
import { VeiculoService } from '../services/veiculo.service';
import { ClienteService } from '../services/cliente.service';
import { UnidadeService } from '../services/unidade.service';
import { ExcelService } from '../services/excel.service';
import { AuthService } from '../services/auth.service';
import * as Datepicker from 'js-datepicker';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import { EspecialidadeVeiculoService } from '../services/especialidade-veiculo.service';
import { ProfissionalService } from '../services/profissional.service';
import { PerfilUsuarioService } from '../services/perfil-usuario.service';

@Component({
	selector: 'app-checklist',
	templateUrl: './checklist.component.html',
	styleUrls: ['./checklist.component.css'],
	animations: [loadingFade, modal, alert]
})
export class ChecklistComponent implements OnInit {

    //Id do menu da tb_menu
    public menu_id = 120; //checklist	

	public loading = false;
	public checklists = [];
	public veiculos = [];
	public tipoVeiculo = [];
	public unidades = [];
	public clientes = [];
	public periodos = [{ periodo: 'D', periodo_nome: 'Diurno'}, { periodo: 'N', periodo_nome: 'Noturno'}];
	public situacoes = [{ situacao: '1', situacao_nome: 'Ativo'}, { situacao: '0', situacao_nome: 'Inativo'}];
	public perfil = this.authSvc.getPerfil();
	public profissionais = [];

	public formFiltro: FormGroup;

	// paginacao
	public page = 1;
	public limit = 10;
	public count = 0;

	// filtro
	public filtro = [];
	public dadosFiltrados = [];
	public showFilter = true;

	//acesso
	public usuario_perfil;
	public visualizar = true;
	public editar = false;
	public usuario_exibir_regiao;
	
	constructor(private fb: FormBuilder,
				// private checkSocorristaSvc: CheckSocorristaService,
				private checkAmbulanciaSvc: CheckAmbulanciaService,
				private clienteSvc: ClienteService,
				private unidadeSvc: UnidadeService,
				private veiculoSvc: VeiculoService,
				private authSvc: AuthService,
				private profissionalSvc: ProfissionalService ,
				private route: ActivatedRoute,
				private router: Router,
				private especialidadeVeiculoSvc: EspecialidadeVeiculoService,				
				private excelSvc: ExcelService,
				private perfilUsuarioSvc: PerfilUsuarioService) { }

	ngOnInit() {


		this.usuario_perfil = this.authSvc.getPerfil();
		//Verifica Permissões Acesso
		this.perfilUsuarioSvc.getByVerificaPermissao(this.usuario_perfil,this.menu_id).then((data: any[]) => {
		if(data[0].editar){
			this.editar = true;
		}
		}).catch((err) => {
		console.log(err);
		});  

		//Verifica perfil de Acesso
		this.getConsultaPorRegiaoOuUsuario();	
		this.criaFiltro();
	}
	
	criaFiltro() {
		this.pegaClientes();
		//this.pegaUnidades();
		//this.pegaVeiculos();
		//this.pegaTipoVeiculos();
		//this.pegaProfissionais()
		this.pegaEspecialidadesVeiculo()
		
		
		this.formFiltro = this.fb.group({
			cliente_id___cliente:null,
			unidade_id___unidade:null,
			veiculo_id___veiculo:null,
			check_ambulancia_turno___periodo:null,
			check_ambulancia_status___status:null, // nao esta sendo usado?
			check_ambulancia_data___data_i: null,
			check_ambulancia_data___data_f: null,
			especialidade_veiculo_id___veiculo: null,
			profissional_id___profissional: null
		});

		let campos_data = ['check_ambulancia_data___data_i', 'check_ambulancia_data___data_f'];
		moment.locale('pt-Br');
		for (let campo of campos_data) {
			Datepicker('#' + campo, {
				customMonths: moment.months(),
				customDays: moment.weekdaysShort(),
				overlayPlaceholder: 'Preencha o ano',
				overlayButton: 'Enviar',
				formatter: (element, date) => {
					let formatted = moment(date).format('DD/MM/YYYY');
					this.formFiltro.controls[campo].setValue(formatted);
				}
			});
		}


		this.route.params.subscribe( params => {

			if(params.id){

				let splitF = params.id.split("&");

				let loCliente_id = null;
				let loUnidade_id = null;
				let loVeiculo_id = null;
				let loTipoVeiculo_id = null;
				let loPeriodo_id = null;
				let loData_i = "";
				let loData_f = "";
				let loProfissional_id = null;

				//this.showFilter = false;

				for (var i = 0; i < splitF.length; i++) {

					var loSplitValor = splitF[i].split("=");

					switch(loSplitValor[0]) { 
						case "cliente_id___cliente": { 

							if(loSplitValor[1] !== "null"){
								this.showFilter = false;
								loCliente_id = parseInt(loSplitValor[1]);
								this.pegaUnidadesFiltro(loSplitValor[1]);
							}
						   break; 

						} 
						case "unidade_id___unidade": { 
							if(loSplitValor[1] !== "null"){
								this.showFilter = false;
								loUnidade_id = parseInt(loSplitValor[1]);
								this.pegaVeiculosEProfissionalFiltro(loUnidade_id,loCliente_id);
							}

						  break; 
						}
						case "veiculo_id___veiculo": { 
							if(loSplitValor[1] !== "null"){
								this.showFilter = false;
						   		loVeiculo_id = parseInt(loSplitValor[1]);
							}
						   break; 
						} 
						case "especialidade_veiculo_id___veiculo": { 
							if(loSplitValor[1] !== "null"){
								this.showFilter = false;
								loTipoVeiculo_id = parseInt(loSplitValor[1]);
							}
							break; 
						}  
						case "check_ambulancia_turno___periodo": { 
							if(loSplitValor[1] !== "null"){
								this.showFilter = false;
						   		loPeriodo_id = loSplitValor[1];
							}
						   break; 
						}     
						case "check_ambulancia_data___data_i": { 
							if(loSplitValor[1] !== "null"){
								this.showFilter = false;
								let splitDate1 = loSplitValor[1].split("-");
								if(splitDate1){
									loData_i = splitDate1[2] + "/" + splitDate1[1] + "/" + splitDate1[0];
								}
							}
						   break; 
						}      
						case "check_ambulancia_data___data_f": { 
							if(loSplitValor[1] !== "null"){
								this.showFilter = false;
								let splitDate1 = loSplitValor[1].split("-");
								if(splitDate1){
									loData_f = splitDate1[2] + "/" + splitDate1[1] + "/" + splitDate1[0];
								}
							}
						   break; 
						}      
						case "profissional_id___profissional": { 
							if(loSplitValor[1] !== "null"){
								this.showFilter = false;
						   		loProfissional_id =  parseInt(loSplitValor[1]);
							}
						   break; 
						}                                                      
					 }

				}
				this.preencheForm({
					cliente_id___cliente: loCliente_id,
					unidade_id___unidade: loUnidade_id,
					veiculo_id___veiculo: loVeiculo_id,
					check_ambulancia_turno___periodo:loPeriodo_id,
					check_ambulancia_status___status:null, // nao esta sendo usado?
					check_ambulancia_data___data_i: loData_i,
					check_ambulancia_data___data_f: loData_f,
					especialidade_veiculo_id___veiculo: loTipoVeiculo_id,
					profissional_id___profissional: loProfissional_id									

				});
				this.filtra();

			}

		});


	}

	preencheForm(dados) {
		this.formFiltro.setValue(dados);
  }

	pegaChecklists() {
		this.checklists = [];
		this.loading = true;

		this.checkAmbulanciaSvc.getCheckAmbulanciaQtde(this.authSvc.getUsuarioId(), this.filtro).then((qtde: any) => {
			this.count = qtde;

			this.checkAmbulanciaSvc.getCheckAmbulanciaByUsuario(this.authSvc.getUsuarioId(), this.filtro, this.page).then((data: any) => {
				this.checklists = data;
				this.loading = false;
			}).catch((err) => {
				this.loading = false;
				console.log(err);
			});
		}).catch((err) => {
			this.loading = false;
			console.log(err);
		});
	}


	pegaChecklistsRegiao() {
		this.checklists = [];
		this.loading = true;

		this.checkAmbulanciaSvc.getCheckAmbulanciaRegiaoQtde(this.authSvc.getUsuarioId(), this.filtro).then((qtde: any) => {
			this.count = qtde;

			this.checkAmbulanciaSvc.getCheckAmbulanciaByRegiao(this.authSvc.getUsuarioId(), this.filtro, this.page).then((data: any) => {
				this.checklists = data;
				this.loading = false;
			}).catch((err) => {
				this.loading = false;
				console.log(err);
			});
		}).catch((err) => {
			this.loading = false;
			console.log(err);
		});
	}

	pegaClientes(){
		this.clienteSvc.getClientesByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
			this.clientes = data;
		});
	}

	pegaUnidades(){
		this.unidadeSvc.getUnidadesByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
			this.unidades = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	onChangeCliente(evento){
		if(typeof evento === 'undefined'){
			return "";
		}else{
			this.formFiltro.controls.unidade_id___unidade.setValue(null);
			this.formFiltro.controls.veiculo_id___veiculo.setValue(null);
			this.loading = true;
	
			this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), evento.cliente_id).then((data: any) => {
				this.unidades = data;
				this.loading = false;
			}).catch((err) => {
				console.log(err);
				this.loading = false;
			});
		}
	}

	pegaUnidadesFiltro(cliente_id){
		if(cliente_id){
			this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), cliente_id).then((data: any) => {
				this.unidades = data;
				this.loading = false;
			}).catch((err) => {
				console.log(err);
				this.loading = false;
			});
		}
	}

	pegaVeiculos(){
		this.veiculoSvc.getAmbulancias(this.authSvc.getUsuarioId()).then((data: any) =>{
			this.veiculos = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	pegaTipoVeiculos(){
		this.veiculoSvc.getByTipoVeiculoFiltro(this.authSvc.getUsuarioId()).then((data: any) =>{
			this.tipoVeiculo = data;
		}).catch((err) => {
			console.log(err);
		});
	}	


	/*pegaEspecialidadesVeiculo() {
		this.especialidadeVeiculoSvc.getEspecialidadesVeiculo('especialidade_veiculo_nome').then((data: any[]) => {
			this.tipoVeiculo = data;
		}).catch((err) => {
			console.log(err);
		});
	}*/

	pegaEspecialidadesVeiculo() {
		this.especialidadeVeiculoSvc.getEspecialidadesVeiculoIn('ambulancia','especialidade_veiculo_nome').then((data: any[]) => {
			this.tipoVeiculo = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	primPagina() {
		this.page = 1;
		this.getConsultaPorRegiaoOuUsuario();
	}

	paginaAnt() {
		this.page = Math.max(this.page - 1, 1);
		this.getConsultaPorRegiaoOuUsuario();	
	}

	proxPagina() {
		this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
		this.getConsultaPorRegiaoOuUsuario();
	}

	ultPagina() {
		this.page = Math.ceil(this.count / this.limit);
		this.getConsultaPorRegiaoOuUsuario();
	}

	filtra() {
		/*this.filtro = this.formFiltro.value;
		this.dadosFiltrados = new FiltroChecklistPipe().transform(this.checklists, this.filtro);
		this.count = this.dadosFiltrados.length;
		this.page = 1;*/
		this.filtro = this.formFiltro.value;
		this.page = 1;

		this.getConsultaPorRegiaoOuUsuario(); 

	}

	apagaChecklist(id) {
		Swal.fire({
			type:'warning',
			title: 'Deseja realmente apagar este registro?',
			showCancelButton: true,
			showCloseButton: true,
			confirmButtonText: 'Apagar',
			cancelButtonText: 'Cancelar',
			confirmButtonColor: '#d33'
			  
		}).then((result) => {
			if(result.value == true){
				if(this.authSvc.getPerfil() == 2){
					this.checkAmbulanciaSvc.apagaCheckAmbulanciaAdmin(id).then((data) => {
						this.getConsultaPorRegiaoOuUsuario();
						Swal.fire({
							type: 'success',
							title: 'Apagado com sucesso!'
						});
					}).catch((err) => {
						console.log(err);
						Swal.fire({
							type: 'error',
							title: 'Ops! Algo de errado aconteceu!',
							text: 'Não foi possível apagar este registro, tente novamente mais tarde.'
						});
					});
				}
				else{
					this.checkAmbulanciaSvc.apagaCheckAmbulancia(id).then((data) => {
						this.getConsultaPorRegiaoOuUsuario();
						Swal.fire({
							type: 'success',
							title: 'Apagado com sucesso!'
						});
					}).catch((err) => {
						console.log(err);
						Swal.fire({
							type: 'error',
							title: 'Ops! Algo de errado aconteceu!',
							text: 'Não foi possível apagar este registro, tente novamente mais tarde.'
						});
					});
				}
				
			}
		})
	}

	exportarExcel(){

		this.perfilUsuarioSvc.getByUsuarioPerfil(this.usuario_perfil).then((data: any) => {
			
			this.usuario_exibir_regiao = data.usuario_exibir_regiao
			if(this.usuario_exibir_regiao == "A"){
				this.gerarExcelRegiao()
			}else{
				this.gerarExcelUsuario();
			}

		}).catch((err) => {
			console.log(err);scrollBy
		});  

	}

	expandPanel(){
		this.showFilter = this.showFilter == true ? false: true;
	}

	print(id){
		//let url = location.href.split('#')[0] + '#' +'(print:print/checkambulancia/'+ id +')'
		//let url = "home/checkambulanciaprint/" + id;
		//window.open(url, 'pagina', "width=1000, height=750");
		this.router.navigate(['home/checkambulanciaprint/' + id]);
	};

	calculaTempoExecucao(inicio, fim){
		if(inicio != null && fim != null){
			inicio = moment(inicio, 'YYYY-MM-DD HH:mm:ss')
			fim = moment(fim, 'YYYY-MM-DD HH:mm:ss')
			let tempo = moment.duration(fim.diff(inicio));
			return  tempo.minutes() + ' m ' + tempo.seconds() + ' s';
		}
		else{
			return null;
		}
		
	}

	deletado(flag){
		return flag == 'S' ? 'deletado' : '';
	}

	EditChecklistAmbulancia(check_ambulancia_id){

		this.filtro = this.formFiltro.value;

		let params = '';

		for (let f in this.filtro) {
			let val = this.filtro[f];
			if (val) {
				let aux = f.split('___');
				if (aux[1] == 'data_i' || aux[1] == 'data_f')
					val = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD');

				params += (params == '')? '?' : '&';
				params += f + "=" + val;
			}
		}

		this.router.navigate(['home/checklist/edit/' + check_ambulancia_id + params]);
	}


	VerChecklistAmbulancia(check_ambulancia_id){

		this.filtro = this.formFiltro.value;

		let params = '';

		for (let f in this.filtro) {
			let val = this.filtro[f];
			if (val) {
				let aux = f.split('___');
				if (aux[1] == 'data_i' || aux[1] == 'data_f')
					val = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD');

				params += (params == '')? '?' : '&';
				params += f + "=" + val;
			}
		}

		this.router.navigate(['home/checklist/ver/' + check_ambulancia_id + params]);
	}

	intercorrencia(checklist_id){
		this.checkAmbulanciaSvc.getCheckAmbulancia(checklist_id).then((data: any) =>{
			Swal.fire({
				title: 'Intercorrência',
				input: 'textarea',
				inputPlaceholder: 'Digite sua mensagem aqui...',
				showCancelButton: true,
				confirmButtonText: 'Enviar',
				inputValue:data.check_ambulancia_intercorrencia,
				inputValidator: (value) => {
					if (!value) {
					  return 'Por favor digite a Intercorrência!'
					}
				}
			}).then((result) => {
				if (result.value) {
					let data = {
						'check_ambulancia_id' : checklist_id,
						'check_ambulancia_intercorrencia' : result.value
					}
	
					this.enviaIntercorrencia(data);
				}
			  })
		});

	}

	enviaIntercorrencia(request){
		this.loading = true;
		this.checkAmbulanciaSvc.criaIntercorrencia(request).then((data) => {
			this.loading = false;
			Swal.fire({
				type:'success',
				title: 'Intercorrencia cadastrada com sucesso!'
			});
		}).catch((err) => {
			this.loading = false;
			Swal.fire({
				type:'error',
				title: 'Ops! Algo de errado aconteceu!',
				text: 'Tente novamente mais tarde.'
			});
		});
	}


	onChangeVeiculoUnidade(e){

		if(typeof e === 'undefined'){
			return "";
		}else{
		this.loading = true;
			this.veiculos = []
			this.veiculoSvc.getByVeiculoClienteUnidadeEspecialidade(e.cliente_id,e.unidade_id,"ambulancia").then((data: any[]) => {
	
			let dados = [];
			for(let veiculo of data){
			  dados.push({
				veiculo_id: veiculo.veiculo_id,
				placa_numero: veiculo.veiculo_placa + ' - ' + veiculo.veiculo_numero,
				unidade_id: e.unidade_id,
				cliente_id: e.cliente_id
			  });
			}
	
			this.veiculos = dados;
			this.pegaProfissionaisClienteUnidade(e)
	
			this.loading = false;
		  }).catch((err) => {
			console.log(err);
		  });
		}
	}


	pegaVeiculosEProfissionalFiltro(unidade_id,cliente_id){

		if(typeof unidade_id === 'undefined'){
			return "";
		}else{
		this.loading = true;
			this.veiculos = []
			this.veiculoSvc.getByVeiculoUnidadeEspecialidade(unidade_id,"ambulancia").then((data: any[]) => {
	
			let dados = [];
			for(let veiculo of data){
			  dados.push({
				veiculo_id: veiculo.veiculo_id,
				placa_numero: veiculo.veiculo_placa + ' - ' + veiculo.veiculo_numero,
				unidade_id: unidade_id,
				cliente_id: cliente_id
			  });
			}
	
			this.veiculos = dados;
			this.pegaProfissionaisClienteUnidadeFiltro(cliente_id,unidade_id)
	
			this.loading = false;
		  }).catch((err) => {
			console.log(err);
		  });
		}
	}

	pegaProfissionaisClienteUnidadeFiltro(cliente_id,unidade_id){
		this.loading = true;
		
		this.profissionalSvc.getProfissionalEdit(cliente_id,unidade_id).then((data: any[]) => {
				this.profissionais = data;
	
		  this.loading = false;
			}).catch((err) => {
				console.log(err);
			});
	  }	


	pegaProfissionaisClienteUnidade(e){
		this.loading = true;
		
		this.profissionalSvc.getProfissionalEdit(e.cliente_id,e.unidade_id).then((data: any[]) => {
				this.profissionais = data;
	
		  this.loading = false;
			}).catch((err) => {
				console.log(err);
			});
	  }	
	
	pegaProfissionais(){
		this.profissionalSvc.getProfissionais().then((data: any[]) => {
				this.profissionais = data;
			}).catch((err) => {
				console.log(err);
			});
	  }

	  
	  onClickLimparCampos(){
		this.pegaClientes();
		this.pegaEspecialidadesVeiculo();		
		
		this.formFiltro = this.fb.group({
			cliente_id___cliente:null,
			unidade_id___unidade:null,
			veiculo_id___veiculo:null,
			check_ambulancia_turno___periodo:null,
			check_ambulancia_status___status:null, // nao esta sendo usado?
			check_ambulancia_data___data_i: null,
			check_ambulancia_data___data_f: null,
			especialidade_veiculo_id___veiculo: null,
			profissional_id___profissional: null
		});

	  }


	  getConsultaPorRegiaoOuUsuario(){

		this.perfilUsuarioSvc.getByUsuarioPerfil(this.usuario_perfil).then((data: any) => {
			
			this.usuario_exibir_regiao = data.usuario_exibir_regiao
			if(this.usuario_exibir_regiao == "A"){
				this.pegaChecklistsRegiao();
			}else{
				this.pegaChecklists();
			}

		}).catch((err) => {
			console.log(err);scrollBy
		});  

	  }


	  gerarExcelUsuario(){

		let data = [];
		//let ultimoId = -1;
		let index = 0;
		
		let localFunction = (ultimoId) => {
			//this.loading = true;
			this.checkAmbulanciaSvc.getCheckAmbulanciaExcel(this.authSvc.getUsuarioId(), this.filtro, ultimoId).then((res:any) => {
				if (res.length > 0) {
					let ultimoId = 0;

					for(let i in res) {
						let row = res[i];

						data[index] = {
							'Central': row.cliente.cliente_nome,
							'Unidade': row.unidade.unidade_nome,
							'Data do Turno': moment(row.check_ambulancia_data).format('DD/MM/YYYY'),
							'Periodo': row.check_ambulancia_turno == 'D' ? 'Diurno' : 'Noturno',
							'Veículo': row.veiculo.veiculo_placa,
							'Quilometragem': this.mascaraKm(row.check_ambulancia_quilometragem),
							'Nome': row.veiculo.veiculo_numero,
							'Tipo de Veículo': row.especialidade_veiculo.especialidade_veiculo_sigla,
							'Profissional': row.profissional.profissional_nome,
							'Tempo de execução': this.calculaTempoExecucao(row.check_ambulancia_inicio,row.check_ambulancia_fim),
							'Data/hora de gravação': row.check_ambulancia_registro? moment(row.check_ambulancia_registro).format('DD/MM/YYYY HH:mm:ss') : '',
						};

						++index;
						ultimoId = row.check_ambulancia_id;
					}

					localFunction(ultimoId);
				}
				else {
					this.excelSvc.exportAsExcelFile(data, 'Chronos Frota - Checklists');
					this.loading = false;
				}
			});
		};

		localFunction(-1);

	  }



	  gerarExcelRegiao(){

		let data = [];
		//let ultimoId = -1;
		let index = 0;
		
		let localFunction = (ultimoId) => {
			//this.loading = true;
			this.checkAmbulanciaSvc.getCheckAmbulanciaExcelRegiao(this.authSvc.getUsuarioId(), this.filtro, ultimoId).then((res:any) => {
				if (res.length > 0) {
					let ultimoId = 0;

					for(let i in res) {
						let row = res[i];

						data[index] = {
							'Central': row.cliente.cliente_nome,
							'Unidade': row.unidade.unidade_nome,
							'Data do Turno': moment(row.check_ambulancia_data).format('DD/MM/YYYY'),
							'Periodo': row.check_ambulancia_turno == 'D' ? 'Diurno' : 'Noturno',
							'Veículo': row.veiculo.veiculo_placa,
							'Quilometragem': this.mascaraKm(row.check_ambulancia_quilometragem),
							'Nome': row.veiculo.veiculo_numero,
							'Tipo de Veículo': row.especialidade_veiculo.especialidade_veiculo_sigla,
							'Profissional': row.profissional.profissional_nome,
							'Tempo de execução': this.calculaTempoExecucao(row.check_ambulancia_inicio,row.check_ambulancia_fim),
							'Data/hora de gravação': row.check_ambulancia_registro? moment(row.check_ambulancia_registro).format('DD/MM/YYYY HH:mm:ss') : '',
						};

						++index;
						ultimoId = row.check_ambulancia_id;
					}

					localFunction(ultimoId);
				}
				else {
					this.excelSvc.exportAsExcelFile(data, 'Chronos Frota - Checklists');
					this.loading = false;
				}
			});
		};

		localFunction(-1);

	  }


	  mascaraKm(valor){

		if(valor != "" && valor != null){

			if(valor.length <= 3){
				return valor;
			}else{

				if(valor.indexOf(".") != -1){

					var sValor = valor.split(".");
					if(sValor[1] == "000"){
						return sValor[0];
					}else{
						return sValor[0] + sValor[1];
					}

				}

			}


		}

	  }





}
